import React, {useEffect} from "react";
import "../CoursePage.sass";

export default function Art() {
    useEffect(() => {
        document.title = 'КьюАй - ART-студия';
    }, [])

    return <>
        <div>
            Родители, КьюАй предлагает вам курс ART-студия, где ваш ребенок сможет раскрыть свой творческий
            потенциал. Занятия проходят в веселой и творческой атмосфере, где мы создаем картины и песочную
            анимацию. Во время урока мы прослушиваем музыку и поем песни, что позволяет раскрыть творческий
            потенциал ребенка. Особый интерес представляет рисование песком, которое помогает гиперактивным
            детям стать более усидчивыми. В курс включены две части: создание картин с применением красок и
            создание рисунка из песка. Это великолепный способ получить яркие эмоции, раскрыть талант и стать
            более уверенным в себе.
        </div>
        <div className="course-footer-second">
            <div className="course-footer-second-ul">
                <div className="course-footer-second-ul-title">
                    Что получит ребёнок?
                </div>
                <ul>
                    <li>Знакомство с различными художественными приемами и техниками;</li>
                    <li>Подготовка теоретической и практической базы в области рисования;</li>
                    <li>Обучение навыкам рисования флоры, фауны, а также предметов вокруг нас;</li>
                    <li>Развитие творческого потенциала и воображения;</li>
                    <li>Выработка уверенность ребенка в своих творческих силах;</li>
                    <li>Развитие мелкой моторики.</li>
                </ul>
            </div>
            <div className="course-footer-second-img">
                <div className="course-footer-second-ac"></div>
            </div>
        </div>
        <div>
            Курс ART-студия в школе КьюАй дарит ученикам незабываемые впечатления и помогает достичь высоких
            творческих результатов. Рисование представляет собой погружение в сказочный мир творчества и
            фантазий, а также интересное и увлекательное занятие, сочетающееся с развитием тактильных ощущений,
            мелкой моторики рук, пластики движений, образного и пространственного мышления, а также улучшением
            памяти и работы мозга. А работа с приятным на ощупь песком дает возможность расслабиться и отдохнуть
            в приятной творческой атмосфере. КьюАй предоставляет уникальную возможность обучения рисованию
            флоры, фауны, абстракции и многое другое. А также знакомство с различными художественными приемами и
            техниками, и подготовка теоретических и практических баз в области рисования.
        </div>
        <div className="course-footer-fourth">
            <div className="course-footer-fourth-img">
                <iframe width="100%" height="100%" src="https://www.youtube.com/embed/mGJzVH9ctHU"
                        title="Рисуем жирафа с детьми" frameBorder="0"
                        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                        allowFullScreen></iframe>
            </div>
        </div>
        <div>
            Позвольте своему ребенку проявить себя в сфере искусства с курсом ART-студия школы КьюАй. Наши
            преподаватели - профессионалы своего дела и помогут вашему ребенку раскрыть свой творческий
            потенциал. Вы можете быть уверены, что ваш ребенок получит качественное образование, которое поможет
            ему стать, возможно, новым Леонардо да Винчи! Не упустите шанс дать ребенку покорить мир искусства!
        </div>
    </>
}